module.exports = __webpack_public_path__ + "assets/images/layers-2x.png";


//////////////////
// WEBPACK FOOTER
// ./~/leaflet/dist/images/layers-2x.png
// module id = 1531
// module chunks = 1